document.addEventListener('DOMContentLoaded', () => {
	const timelineBlocks = document.querySelectorAll('.wp-block-kaloncom-timeline');
	if (!timelineBlocks.length) return;

	const updateProgress = () => {
		const windowHeight = window.innerHeight;
		const triggerPoint = windowHeight / 2; // La ligne se remplit quand elle passe le milieu de l'écran

		timelineBlocks.forEach(block => {
			const rect = block.getBoundingClientRect();
			
			// Calcul de la progression : 
			// 0 = le haut du bloc touche le milieu de l'écran
			// 1 = le bas du bloc touche le milieu de l'écran
			let progress = (triggerPoint - rect.top) / rect.height;

			// On s'assure que la valeur reste bloquée entre 0 (vide) et 1 (pleine)
			progress = Math.max(0, Math.min(1, progress));

			// On envoie cette variable personnalisée (--scroll-progress) au CSS
			block.style.setProperty('--scroll-progress', progress);

			// On allume le point central quand la ligne l'atteint (à la moitié du bloc)
			if (progress >= 0.5) {
				block.classList.add('is-active');
			} else {
				block.classList.remove('is-active');
			}
		});
	};

	// requestAnimationFrame permet de fluidifier l'animation sans surcharger le navigateur
	window.addEventListener('scroll', () => {
		requestAnimationFrame(updateProgress);
	}, { passive: true });

	// On lance le calcul une fois au chargement pour les blocs déjà visibles
	updateProgress();
});